import { useState, type FocusEvent } from 'react';

interface UseFocusWithinOptions {
  isWithin?: (target: HTMLElement) => boolean;
  // Called once focus has moved outside the element.
  onLeave?: () => void;
}

export function useFocusWithin({
  isWithin,
  onLeave,
}: UseFocusWithinOptions = {}) {
  const [isFocusedWithin, setIsFocusedWithin] = useState(false);

  const handleFormFocus = () => setIsFocusedWithin(true);
  const handleFormBlur = (event: FocusEvent<HTMLFormElement>) => {
    const nextTarget = event.relatedTarget as HTMLElement | null;
    if (event.currentTarget.contains(nextTarget)) return;
    if (nextTarget && isWithin?.(nextTarget)) return;
    setIsFocusedWithin(false);
    onLeave?.();
  };

  return {
    isFocusedWithin,
    setIsFocusedWithin,
    handleFormFocus,
    handleFormBlur,
  };
}
